import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { MatButtonModule } from '@angular/material/button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from '@angular/material/button';
import * as ɵngcc4 from '@fortawesome/angular-fontawesome';

function PsyBreadcrumbsComponent_div_0_span_3_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, " / ");
    ɵngcc0.ɵɵelementEnd();
} }
function PsyBreadcrumbsComponent_div_0_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelementStart(1, "a", 6);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, PsyBreadcrumbsComponent_div_0_span_3_span_3_Template, 2, 0, "span", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const headingLink_r4 = ctx.$implicit;
    const last_r5 = ctx.last;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", headingLink_r4.routerLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", headingLink_r4.name, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !last_r5);
} }
function PsyBreadcrumbsComponent_div_0_button_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 8);
    ɵngcc0.ɵɵelement(1, "fa-icon", 9);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r2.addFormLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r2.faPlus);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.addButtonLabel, " ");
} }
function PsyBreadcrumbsComponent_div_0_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 10);
    ɵngcc0.ɵɵlistener("click", function PsyBreadcrumbsComponent_div_0_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.clickDelete(); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 9);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r3.faTrash);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.deleteButtonLabel, " ");
} }
function PsyBreadcrumbsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "h2");
    ɵngcc0.ɵɵtemplate(3, PsyBreadcrumbsComponent_div_0_span_3_Template, 4, 3, "span", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div");
    ɵngcc0.ɵɵtemplate(5, PsyBreadcrumbsComponent_div_0_button_5_Template, 3, 3, "button", 4);
    ɵngcc0.ɵɵtemplate(6, PsyBreadcrumbsComponent_div_0_button_6_Template, 3, 2, "button", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.headingLinks);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.addButtonLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.deleteButtonLabel);
} }
class PsyBreadcrumbsComponent {
    constructor() {
        this.headingLinks = [];
        this.clickDeleteEvent = new EventEmitter();
        this.faPlus = faPlus;
        this.faTrash = faTrash;
    }
    clickDelete() {
        this.clickDeleteEvent.emit();
    }
    ;
}
PsyBreadcrumbsComponent.ɵfac = function PsyBreadcrumbsComponent_Factory(t) { return new (t || PsyBreadcrumbsComponent)(); };
PsyBreadcrumbsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PsyBreadcrumbsComponent, selectors: [["psy-breadcrumbs"]], inputs: { headingLinks: "headingLinks", addButtonLabel: "addButtonLabel", addFormLink: "addFormLink", deleteButtonLabel: "deleteButtonLabel" }, outputs: { clickDeleteEvent: "clickDeleteEvent" }, decls: 1, vars: 1, consts: [["class", "headingLink", 4, "ngIf"], [1, "headingLink"], [1, "heading"], [4, "ngFor", "ngForOf"], ["mat-raised-button", "", "color", "primary", 3, "routerLink", 4, "ngIf"], ["mat-raised-button", "", "color", "warn", 3, "click", 4, "ngIf"], [3, "routerLink"], [4, "ngIf"], ["mat-raised-button", "", "color", "primary", 3, "routerLink"], [3, "icon"], ["mat-raised-button", "", "color", "warn", 3, "click"]], template: function PsyBreadcrumbsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PsyBreadcrumbsComponent_div_0_Template, 7, 3, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.headingLinks);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc2.RouterLinkWithHref, ɵngcc3.MatButton, ɵngcc2.RouterLink, ɵngcc4.FaIconComponent], styles: [".headingLink[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:space-between}.heading[_ngcontent-%COMP%] > h2[_ngcontent-%COMP%]{font-weight:bolder}"] });
PsyBreadcrumbsComponent.propDecorators = {
    headingLinks: [{ type: Input }],
    addButtonLabel: [{ type: Input }],
    addFormLink: [{ type: Input }],
    deleteButtonLabel: [{ type: Input }],
    clickDeleteEvent: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PsyBreadcrumbsComponent, [{
        type: Component,
        args: [{
                selector: 'psy-breadcrumbs',
                template: "<div *ngIf=\"headingLinks\" class=\"headingLink\">\r\n    \r\n    <div class=\"heading\">\r\n        <h2>\r\n            <span *ngFor=\"let headingLink of headingLinks; let last = last\"> \r\n                <a [routerLink]=\"headingLink.routerLink\"> {{ headingLink.name }} </a> \r\n                <span *ngIf=\"!last\"> / </span>\r\n            </span>\r\n        </h2>\r\n    </div>\r\n\r\n    <div>\r\n        <button mat-raised-button color=\"primary\" *ngIf=\"addButtonLabel\" [routerLink]=\"addFormLink\">\r\n            <fa-icon [icon]=\"faPlus\"></fa-icon> {{ addButtonLabel }}\r\n        </button>\r\n        <button mat-raised-button color=\"warn\" *ngIf=\"deleteButtonLabel\" (click)=\"clickDelete()\">\r\n            <fa-icon [icon]=\"faTrash\"></fa-icon> {{ deleteButtonLabel }}\r\n        </button>\r\n    </div>\r\n</div>\r\n",
                styles: [".headingLink{align-items:center;display:flex;justify-content:space-between}.heading>h2{font-weight:bolder}"]
            }]
    }], function () { return []; }, { headingLinks: [{
            type: Input
        }], clickDeleteEvent: [{
            type: Output
        }], addButtonLabel: [{
            type: Input
        }], addFormLink: [{
            type: Input
        }], deleteButtonLabel: [{
            type: Input
        }] }); })();
;

class PsyBreadcrumbsModule {
}
PsyBreadcrumbsModule.ɵfac = function PsyBreadcrumbsModule_Factory(t) { return new (t || PsyBreadcrumbsModule)(); };
PsyBreadcrumbsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PsyBreadcrumbsModule });
PsyBreadcrumbsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            MatButtonModule,
            FontAwesomeModule,
            RouterModule.forChild([])
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PsyBreadcrumbsModule, [{
        type: NgModule,
        args: [{
                declarations: [PsyBreadcrumbsComponent],
                imports: [
                    CommonModule,
                    MatButtonModule,
                    FontAwesomeModule,
                    RouterModule.forChild([])
                ],
                exports: [PsyBreadcrumbsComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PsyBreadcrumbsModule, { declarations: function () { return [PsyBreadcrumbsComponent]; }, imports: function () { return [CommonModule,
        MatButtonModule,
        FontAwesomeModule, ɵngcc2.RouterModule]; }, exports: function () { return [PsyBreadcrumbsComponent]; } }); })();

/*
 * Public API Surface of psy-breadcrumbs
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PsyBreadcrumbsComponent, PsyBreadcrumbsModule };

